import LocalHospitalOutlined from '@mui/icons-material/LocalHospitalOutlined'

import Stack from '@mui/material/Stack'

import Section from '@components/Details/Section'

import Field from './Field'

export default function LHCDetails({ data, isLoading }) {
  const lhc = data?.lhcDetails

  return (
    <Section title="LHC Details" icon={<LocalHospitalOutlined />}>
      <Stack sx={{ gap: 1 }}>
        <Field label="Participating in LHC" isLoading={isLoading} value={lhc?.participatingInLHC ? 'Yes' : 'No'} />
        {lhc?.participatingInLHC ? (
          <>
            <Field label="LHC CBO Linkage Contact" isLoading={isLoading} value={lhc?.lhcCboLinkageContact} />
            <Field label="Area Requests" isLoading={isLoading} value={lhc?.areaRequests} />
          </>
        ) : (
          <Field label="HIV CBO Linkage Contact" isLoading={isLoading} value={lhc?.hivCboLinkageContact} />
        )}
        <Field label="Additional Notes" isLoading={isLoading} value={lhc?.lhcAdditionalNotes} />
      </Stack>
    </Section>
  )
}
